import React from 'react';

/**
 * A stylized visual block for sections that need high-end "dashboard screenshot" or "abstract brand" visuals
 * Uses CSS and icons to avoid broken external media issues.
 */
export const VisualCard = ({ type = "dashboard", title, className = "" }) => {
  return (
    <div className={`relative w-full aspect-video rounded-lg overflow-hidden bg-chefBlack border border-chefPanel group ${className}`}>
      {type === "dashboard" && (
        <div className="absolute inset-0 p-4 flex flex-col gap-2">
          {/* Mock Dashboard UI */}
          <div className="flex gap-2">
            <div className="w-8 h-2 bg-chiliRed/40 rounded-full"></div>
            <div className="w-12 h-2 bg-chefPanel rounded-full"></div>
          </div>
          <div className="flex-1 grid grid-cols-3 gap-2">
            {[...Array(6)].map((_, i) => (
              <div key={i} className={`rounded-sm border border-chefPanel/50 ${i === 1 ? 'bg-chiliRed/10 border-chiliRed/30' : 'bg-chefDark'}`}></div>
            ))}
          </div>
          <div className="h-4 bg-chefPanel/30 rounded-sm"></div>
        </div>
      )}

      {type === "kitchen" && (
        <div className="absolute inset-0 flex items-center justify-center bg-gradient-to-br from-chefDark to-chefBlack">
          <div className="relative w-3/4 h-2/3 border border-chefPanel rounded-md p-3 flex flex-col gap-2">
            <div className="flex justify-between border-b border-chefPanel pb-1">
              <div className="w-1/3 h-1.5 bg-status-open/30 rounded-full"></div>
              <div className="w-4 h-1.5 bg-chiliRed rounded-full animate-pulse"></div>
            </div>
            {[...Array(4)].map((_, i) => (
              <div key={i} className="flex gap-2 items-center">
                <div className="w-2 h-2 rounded-full border border-chefPanel"></div>
                <div className="flex-1 h-1 bg-chefPanel/40 rounded-full"></div>
              </div>
            ))}
          </div>
        </div>
      )}

      {type === "inventory" && (
        <div className="absolute inset-0 flex items-center justify-center">
           <div className="flex gap-1 items-end h-1/2">
             {[30, 70, 45, 90, 20, 55].map((h, i) => (
               <div key={i} style={{ height: `${h}%` }} className={`w-3 rounded-t-sm ${h < 30 ? 'bg-chiliRed' : 'bg-chefPanel'}`}></div>
             ))}
           </div>
        </div>
      )}

      <div className="absolute inset-0 bg-gradient-to-t from-chefBlack via-transparent to-transparent opacity-60 group-hover:opacity-40 transition-opacity"></div>
      
      {title && (
        <div className="absolute bottom-3 left-4">
          <span className="text-[10px] font-mono text-receiptWhite uppercase tracking-widest">{title}</span>
        </div>
      )}
    </div>
  );
};